import request, { METHODS } from "src/utils/api-base";

const warehouseApis = {
  createWarehouse: (payload: any) => {
    return request({
      route: "/app/warehouses",
      method: METHODS.POST,
      payload,
      auth: true,
    });
  },

  getWarehouseList: (params: {
    page?: number;
    limit: number;
    status?: "active" | "inactive";
    search?: string;
  }) => {
    return request({
      route: "/app/warehouses",
      method: METHODS.GET,
      params,
      auth: true,
    });
  },

  editWarehouse: (payload: any) => {
    return request({
      route: `/app/warehouses/${payload._id}`,
      method: METHODS.PUT,
      payload,
      auth: true,
    });
  },

  deleteWarehouse: (_id: string) => {
    return request({
      route: `/app/warehouses/${_id}`,
      method: METHODS.DELETE,
      auth: true,
    });
  },
};

export default warehouseApis;
